// filter user locations based on available locations in web
export const handleListLocations =(UserLocations, ListleLocations) => {
    if (ListleLocations === undefined || ListleLocations === null || ListleLocations === '') {
        return []
    }
    const AvailableLocations = ListleLocations.split(',')

    return UserLocations.filter(element=>AvailableLocations.includes(element.LocationDescription))
}